import { render, staticRenderFns } from "./unsubscribers.vue?vue&type=template&id=a76b4c18&scoped=true"
import script from "./unsubscribers.vue?vue&type=script&lang=js"
export * from "./unsubscribers.vue?vue&type=script&lang=js"
import style0 from "./unsubscribers.vue?vue&type=style&index=0&id=a76b4c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76b4c18",
  null
  
)

export default component.exports